<template>
  <div class="basic-info" id="basic-info">
    <div class="top-btn" v-if="permission['JZYTXXMXX'].isShow">
      <div class="btn" @click="showSelectUnit">
        <img src="@/assets/img/opinionPublish/project_icon.png">
        <span>{{ permission['JZYTXXMXX'].label }}</span>
      </div>
    </div>
    <div class="basic-info-box">
      <div class="box-title">{{ navTitle }}</div>
      <div v-for="(item, index) in listData" :key="index">
        <!--项目地址-->
        <div class="xzq" v-if="item.isShow && item.key=='XZQ'">
          <appoint-input
            style="flex: 1;"
            :title="item.label"
            :placeholder="item.placeholder"
            :isCheck="item.isCheck"
            :dictKey="item.dictKey"
            v-model="componentData[item.key]"
            :type="item.type"
            ref="XZQ"
          />
          <appoint-input
            class="xxdz"
            title="详细地址"
            :placeholder="permission['GCXXDD'].placeholder"
            :dictKey="permission['GCXXDD'].dictKey"
            v-model="componentData['GCXXDD']"
            :type="permission['GCXXDD'].type"
          />
        </div>
        <appoint-input
          v-else-if="item.isShow &&item.key!='GCXXDD'&& (item.type ? item.type != 'button' : false)"
          :title="item.label"
          :placeholder="item.placeholder"
          :isCheck="item.isCheck"
          :dictKey="item.dictKey"
          v-model="componentData[item.key]"
          :type="item.type"
          :titleButton="item.key == 'GCBH' ? permission.DQXMXX : {}"
          @titleClick="titleClick"
        />
      </div>
 
    </div>
    <div class="btn-group">
      <van-button plain type="info" @click="toPrev">上一步</van-button>
      <van-button type="info" class="btn"  @click="saveData(2)">暂存</van-button>
      <van-button type="info" @click="toNext">下一步</van-button>
    </div>
    <appoint-unit ref="AppointUnit"></appoint-unit>
  </div>
</template>

<script>
import AppointInput from "@/components/ProjectAppoint/appoint-input.vue";
import AppointUnit from "@/components/ProjectAppoint/appoint-unit.vue";
import api from "@/utils/api/appoint";
import moduleMixins from "@/mixins/moduleMixins";
import appointMixins from "@/mixins/appointMixins";
const DQXMXX = "DQXMXX";
const GCBH = "GCBH";
const XZQ = "XZQ";

export default {
  name: "CommonFormFinal",
  components: { AppointInput, AppointUnit },
  mixins: [moduleMixins, appointMixins],
  props: {},
  data() {
    return {
      listData: [],
    };
  },
  watch: {
    permission:{
      handler(newVal,oldVal){
        //旧数据是空数据，要将新数据的默认值添加到componentData
        if(!oldVal){
          for(const key in newVal){
            const defaultVal = newVal[key].defaultVal
            if(defaultVal){
              this.componentData[key] = defaultVal
            }
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    navTitle() {
      return "项目信息";
    },
    isCheck() {
      let isCheck = true;
      if (Object.keys(this.componentData).length == 0) {
        return false;
      }
      //必填项
      for (let key in this.permission) {
        const permission = this.permission[key]
        // type 是空和button 要跳过
        if(permission.type==''||permission.type=='button'){
          continue
        }
        // 判断isCheck是true；isShow是true
        if (permission.isCheck === true&&permission.isShow == true && !this.componentData[key]) {
          isCheck = false
        }
      }
      return isCheck;
    },
  },
  methods: {
    // loadData() {
    //   api.getBaseComponentConfig().then((res) => {
    //     let DQXMXXData = {};
    //     res.forEach((element) => {
    //       this.$set(this.componentData, element.FIELD_KEY, element.DEFAULT_VAL);
    //       //  this.componentData[element.FIELD_KEY] = element.DEFAULT_VAL
    //       if (element.FIELD_KEY == DQXMXX) {
    //         DQXMXXData = element;
    //       }
    //     });
    //     if (Object.keys(DQXMXXData).length > 0) {
    //       for (let data of res) {
    //         if (data.FIELD_KEY == GCBH) {
    //           data.titleButton = DQXMXXData;
    //           break;
    //         }
    //       }
    //     }
    //     this.listData = res;
    //     console.log("component:", res);
    //   });
    // },
    dealData(){
      let list=[]
      this.permission.commonFieldSort.forEach(key => {
        list.push(this.permission[key])
      });
      this.listData = list

      if(!this.componentData.LXR) {
        // 获取用户信息注入
        let userInfo = this.$store.state.userInfo
        this.componentData.LXR = userInfo.LXR
        this.componentData.LXDH = userInfo.mobilePhone
        this.componentData.DZYX = userInfo.mailBox
        this.componentData.WTDW = userInfo.DWMC
      }
    },
    toNext() {
      if(this.isCheck){
        this.$router.push({
          name: "CascaderSelect",
        });
      }else{
        this.$toast('请填写全部必填项')
      }
    },
    toPrev(){
      // this.onClickLeft()
      this.$router.push({name:'ShowProtocol'})
    },
    showSelectUnit() {
      this.$refs["AppointUnit"].showUnit = true;
    },
    titleClick(val) {
      if (val.buttonKey == DQXMXX) {
        // let code = ''
        // let xzq = ''
        // this.list.forEach(element=>{
        //   if(element.FIELD_KEY==XZQ){
        //     xzq = element.
        //   }
        // })
        let params = {
          code: this.componentData[GCBH],
          xzq: this.componentData[XZQ],
        };
        api
          .getGGProjectInfo(params)
          .then((res) => {
            console.log(res.data.rowsList);
            if (res.data.rowsList.length > 0) {
              const data = res.data.rowsList[0];
              console.log("data", data);
              for (const key in data) {
                // 详细地址是获取XMXXDZ
                if(key == 'XMXXDZ') {
                  this.$set(this.componentData, 'GCXXDD', data['XMXXDZ'])
                } else {
                  this.$set(this.componentData, key, data[key])
                }
              }
              let options = this.$refs['XZQ'][0].options
              options.forEach(item => {
                console.log(item.showValue, data['XZQ'])
                if(item.showValue == data['XZQ']) this.componentData['XZQCode'] = item.code
              })
            } else {
              this.$toast("无此项目信息");
            }
            console.log(res.rowsList);
          })
          .catch((err) => {
            this.$toast("无此项目信息");
          });
      }
    },
    saveData() {
      this.saveTempData('CommonFormFinal')
    },
  },
  created() {},
  mounted() {
    this.dealData()
    // this.loadData();
  },
};
</script>
<style lang="scss" scoped>
.basic-info {
  height: 100%;
  &.noScroll {
    overflow: hidden;
    height: 100vh;
  }
  .top-btn {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 15px;
    .btn {
      width: 100%;
      height: 6vh;
      color: #fff;
      background-image: url("../../assets/img/opinionPublish/project_bg.png");
      background-size: cover;
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 26px;
        margin: 0 10px;
      }
      span {
        color: #1d84ff;
      }
    }
  }
  .basic-info-box {
    background-color: #fff;
    margin-bottom: 65px;
    padding: 10px 15px;
    .box-title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      padding: 10px 0px;
    }
    .tips {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      padding-top: 10px;
      span {
        color: #1d84ff;
        text-decoration: underline;
      }
    }
    .project-service {
      padding: 10px 10px;
      border: 1px solid #dddddd;
      .service-title {
        font-size: 14px;
        padding: 10px 0px;
        font-weight: bold;
        color: #333333;
      }
      .checkbox {
        padding: 10px 0px;
        font-size: 14px;
        color: #333333;
      }
    }
    // .no-btn {
    //   background: #cfcfcf;
    //   box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.5);
    //   border-radius: 5px;
    //   padding: 14px 0;
    //   font-size: 14px;
    //   font-weight: 500;
    //   color: #ffffff;
    //   border: 1px solid transparent;
    //   margin-top: 20px;
    //   text-align: center;
    // }

    // .btn {
    //   background: #0086ff;
    //   box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
    //   border-radius: 5px;
    //   font-size: 14px;
    //   font-weight: 500;
    //   color: #ffffff;
    //   padding: 14px 0;
    //   border: 1px solid transparent;
    //   margin-top: 20px;
    //   text-align: center;
    // }

    .picker {
      ::v-deep .van-picker__toolbar {
        border-bottom: 1px solid #dddddd;
      }
      ::v-depp .van-picker__confirm {
        color: #1d84ff;
      }
      ::v-deep .van-picker-column__item {
        color: #999999;
      }
      ::v-deep .van-picker__cancel {
        color: #999999;
      }
      ::v-deep .van-picker__mask {
        background-image: none;
      }
      ::v-deep .van-picker-column__item--selected {
        color: #1d84ff;
      }
    }

    .xzq {
      display: flex;
      .xxdz {
        flex: 2;
        margin-left: 10px;
        ::v-deep .appoint-title {
          opacity: 0;
        }
      }
    }
  }
  .btn-group {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    // box-shadow: 0px -5px 5px -5px #ccc;
    border-top: 1px solid #eee;
    .btn {
      padding: 14px 20px;
      font-weight: 500;
      color: #ffffff;
      border: 1px solid transparent;
    }
  }
}
</style>
